<template>
  <div>
    <div style="margin:1%">
      <b-col style="margin:5px">
        <md-button @click.stop="showSelectDocuments" class="md-raised">{{ $t('Add') }}</md-button>
      </b-col>
      <b-table small striped hover :items="documents" :fields="fieldsDocuments">
        <template v-slot:cell(uploaded)="data">
          <b-form-checkbox disabled v-model="data.value"/>
        </template>
        <template v-slot:cell(actions)="row">
          <i @click.stop="ClickOnDownloadContractButton(row)" class="primary fa fa-file-export fa-lg"/>
          <i @click.stop="ClickOnDeleteDocumentsButton(row)" class="danger fa fa-trash-alt fa-lg"/>
        </template>
      </b-table>
    </div>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteDocuments">
      <h5>{{ $t('Are you sure you want to delete one of "Documents"?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteDocuments()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideDeleteDocuments()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="selectDocuments" hide-footer :title="$t('New contract')">
      <FormSelectDocuments :currentRow="currentRow" @hideSelectDocuments="hideSelectDocuments"/>
    </b-modal>
  </div>
</template>

<script>
import download from '@/utils/downloadFile'
import FormSelectDocuments from './formSelectDocuments'
export default {
  components: {
    FormSelectDocuments
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      curDocument: null,
      fileName: '',
      isShowSelectDocuments: false,
      fieldsDocuments: [
        { key: 'contract_id', label: this.$i18n.t('Documents ID'), sortable: true },
        { key: 'template_id', label: this.$i18n.t('Template ID'), sortable: true },
        { key: 'created', label: this.$i18n.t('Date of creation'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) } },
        { key: 'name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'path', label: this.$i18n.t('Path'), sortable: true },
        { key: 'uploaded', label: this.$i18n.t('Uploaded'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ]
    }
  },
  methods: {
    ClickOnDeleteDocumentsButton (row) {
      this.curDocument = row.item
      this.$refs.modalDeleteDocuments.show()
    },
    hideDeleteDocuments () {
      this.$refs.modalDeleteDocuments.hide()
    },
    deleteDocuments () {
      if (this.curDocument) {
        let response = this.$store.dispatch('Users/DELETE_CONTRACTS', this.curDocument.contract_id)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_CONTRACTS', this.currentRow.user_id)
            this.$root.$emit('makeToasts')
            this.$refs.modalDeleteDocuments.hide()
          }
        })
      }
    },
    showSelectDocuments () {
      this.$refs.selectDocuments.show()
    },
    hideSelectDocuments () {
      this.$refs.selectDocuments.hide()
    },
    ClickOnDownloadContractButton (row) {
      this.fileName = row.item.path
      let response = this.$store.dispatch('Users/DOWNLOAD_CONTRACTS', row.item.contract_id)
      response.then(response => {
        download(response.data, this.fileName, 'application/pdf')
      })
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_DOCUMENT_TEMPLATES')
    this.$store.dispatch('Users/GET_CONTRACTS', this.currentRow.user_id)
  },
  computed: {
    documents () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Users/CONTRACTS']))
      for (let el of copy) {
        el.uploaded = JSON.parse(JSON.stringify(el.template_id)) === 0
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/documents/main.vue